module.exports = __webpack_public_path__ + "img/logo-10.b404df6a.png";